/*
  salt&spirit. · ss-extras.js (29-sep-2026) — aviso al agregar, barra fija de la home y compras pasadas reales.
  Markup en snippets/ss-compras.liquid. Funciones globales para los onclick (sobreviven re-render de Dawn).
*/
(function () {
  if (window.__ssExtras) return;
  window.__ssExtras = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(s, r) { return (r || document).querySelector(s); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- 1) aviso «✓ agregado» ---------- */
  var toastT = null;
  window.ssToastClose = function () {
    var t = $('#ss-toast'); if (!t) return;
    t.classList.remove('is-on'); clearTimeout(toastT);
    setTimeout(function () { t.hidden = true; }, 250);
  };
  window.ssOpenCart = function () {
    window.ssToastClose();
    var d = $('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  };
  function showToast(name) {
    var t = $('#ss-toast'); if (!t) return;
    var n = $('[data-ss-toast-name]', t); if (n) n.textContent = name || 'Producto';
    t.hidden = false; void t.offsetWidth; t.classList.add('is-on');
    window.ssPopClose(true);
    clearTimeout(toastT); toastT = setTimeout(window.ssToastClose, 5000);
  }
  function hookCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false; /* PUB_SUB_EVENTS es const global, no vive en window */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== 'product-form') return;
      var d = e.cartData || {};
      var name = d.product_title || (d.items && d.items[0] && d.items[0].product_title) || '';
      showToast(name);
    });
    return true;
  }

  /* ---------- 2) barra fija de la home ---------- */
  window.ssHctaGo = function (ev) {
    var tgt = document.getElementById('comprar');
    if (!tgt) return;
    if (ev) ev.preventDefault();
    tgt.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
  };
  function initHcta() {
    var bar = $('#ss-hcta'); if (!bar || !('IntersectionObserver' in window)) return;
    var btn = $('.ss-hcta__btn', bar);
    var seen = new Set(), passedHero = false;
    function update() {
      var on = passedHero && seen.size === 0 && !document.body.classList.contains('overflow-hidden');
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('ss-hcta-on', on);
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      update();
    });
    /* se retira cuando hay a la vista otro botón de compra: el de la sección Comprar, el del hero, el cierre o el footer */
    ['#comprar', '.ss-cta__btns', '.shopify-section-group-footer-group'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { io.observe(el); });
    });
    var hero = document.querySelector('.ss-hero, [id*="__hero"]');
    if (hero) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { passedHero = !e.isIntersecting && e.boundingClientRect.top < 0; }); update(); }).observe(hero);
    } else passedHero = true;
    update();
  }

  /* ---------- 3) compras pasadas reales, sin fecha ---------- */
  var pop = null, list = [], idx = 0, popT = null, shown = 0, MAX = 6;
  window.ssPopClose = function (soft) {
    if (!pop) return;
    pop.classList.remove('is-on');
    setTimeout(function () { if (pop) pop.hidden = true; }, 250);
    if (!soft) { store('ss-pop-off', '1'); clearTimeout(popT); }
  };
  var COL = { 'Pure Blue': '#2f5fd0', 'Vital Red': '#b41824', 'Hydra-Rest': '#5b3fb5', 'MIX Box': 'linear-gradient(135deg,#b41824,#2f5fd0 55%,#5b3fb5)' };
  function nextPop() {
    if (!pop || store('ss-pop-off') || shown >= MAX || !list.length) return;
    if (document.body.classList.contains('overflow-hidden') || (document.getElementById('ss-toast') || {}).hidden === false) { popT = setTimeout(nextPop, 8000); return; }
    var c = list[idx % list.length]; idx++; shown++;
    var links = {}; try { links = JSON.parse(pop.getAttribute('data-links') || '{}'); } catch (e) {}
    $('[data-ss-pop-text]', pop).textContent = c.n + (c.c ? ' de ' + c.c : '') + ' compró ' + c.p;
    var a = $('[data-ss-pop-link]', pop); a.href = links[c.p] || '#';
    var dot = $('[data-ss-pop-dot]', pop); dot.style.background = COL[c.p] || '#121212';
    pop.hidden = false; void pop.offsetWidth; pop.classList.add('is-on');
    popT = setTimeout(function () { window.ssPopClose(true); popT = setTimeout(nextPop, 22000); }, 6000);
  }
  function initPop() {
    pop = $('#ss-pop'); if (!pop || store('ss-pop-off') || !window.fetch) return;
    fetch(pop.getAttribute('data-src'), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.activo || !d.compras || d.compras.length < 3) return;
        list = d.compras.slice();
        var s = parseInt(store('ss-pop-i') || '0', 10) || 0; idx = s;
        window.addEventListener('pagehide', function () { store('ss-pop-i', String(idx)); });
        popT = setTimeout(nextPop, 12000);
      })
      .catch(function () {});
  }

  function boot() {
    if (!hookCart()) setTimeout(hookCart, 800);
    initHcta();
    initPop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
